class Plans {
  constructor() {
    this.quizPage = document.getElementById('quiz')?.dataset.quizUrl || '/pages/quiz';
    this.currency = {'code': 'USD', 'symbol': '$'};
    this.preview = Shopify.theme.role === 'unpublished';
    this.isAbandonCart = document.getElementById('abandon-cart');
    this.isPlanActions = document.getElementById('plan-actions');
    this.debug = this.preview || window.location.search.indexOf('sdebug=1') !== -1;
    this.init();
  }

  init() {
    if (this.isAbandonCart) {
      this.initializeAbandonCartPage();
    } else if (this.isPlanActions) {
      this.initializePlanActionsPage();
    } else {
      this.initializePlansPage();
    }
  }

  initializePlansPage() {
    this.adjustCart();
    this.initializeModal();

    document.querySelectorAll('.plan').forEach(plan => {
      plan.addEventListener('click', (e) => {
        const plan = e.target.closest('.plan');
        if (plan.classList.contains('selected')) return;

        document.querySelectorAll('.plan.selected').forEach(p => {
          p.classList.remove('selected');
        });

        plan.classList.add('selected');
      });
    });

    document.getElementById('back-button').addEventListener('click', (e) => {
      e.preventDefault();
      const returnStep = new URLSearchParams(window.location.search).get('returnStep');
      window.location.href = this.quizPage + (returnStep ? '?step=' + returnStep : '');
    });

    document.getElementById('checkout-button').addEventListener('click', (e) => {
      e.preventDefault();

      const selectedPlan = document.querySelector('.plan.selected');
      if (!selectedPlan) {
        alert('Please select a plan before continuing.');
        return;
      }

      const variantId = selectedPlan.dataset.variantId;
      const sellingPlan = selectedPlan.dataset.sellingPlan;
      const upsell = selectedPlan.dataset.upsell;

      this.selectPlan(variantId, sellingPlan, upsell);
    });
  }

  initializeAbandonCartPage() {
    this.adjustCart();
    this.initializeModal();

    const urlParams = new URLSearchParams(window.location.search);
    let planName = urlParams.get('plan');
    if (!planName) {
      planName = 'regal';
    }
    planName = planName.toLowerCase();

    document.querySelectorAll('.plan').forEach(plan => {
      if (plan.querySelector('.plan-title').textContent.toLowerCase().indexOf(planName) !== -1) {
        plan.classList.add('selected');
      }
    });

    document.getElementById('checkout-button').addEventListener('click', (e) => {
      e.preventDefault();

      const selectedPlan = document.querySelector('.plan.selected');

      const variantId = selectedPlan.dataset.variantId;
      const sellingPlan = selectedPlan.dataset.sellingPlan;

      this.selectPlan(variantId, sellingPlan);
    });
  }

  initializePlanActionsPage() {
    this.adjustCart();
    this.initializeModal();

    const urlParams = new URLSearchParams(window.location.search);
    let planName = urlParams.get('plan');
    if (planName) {
      planName = planName.toLowerCase();

      document.querySelectorAll('.plan').forEach(plan => {
        if (plan.querySelector('.plan-title').textContent.toLowerCase().indexOf(planName) !== -1) {
          plan.classList.add('selected');
        }
      });
    }

    this.initializePlanActionsCTA();
    this.initializeSelectionModal('plan');
    this.initializeSelectionModal('cadence');
    this.getSubscriptionDetails();
  }

  initializePlanActionsCTA() {
    document.getElementById('action-button').addEventListener('click', (e) => {
      document.querySelector('.cta span').style.opacity = '0';
      document.querySelectorAll('.cta button').forEach(button => {
        button.style.opacity = '0.2';
        button.style.cursor = 'wait';
        button.addEventListener('click', (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
        });
      });
      e.preventDefault();

      const subscriptionId = document.querySelector('.plan-actions').dataset.subscriptionId;
      const cadence = document.querySelector('.plan-actions').dataset.cadence;

      const selectedPlan = document.querySelector('.plan.selected');

      const productId = selectedPlan.dataset.productId;
      const variantId = selectedPlan.dataset.variantId;
      const discount = selectedPlan.dataset.discount;

      const url = statelyVars.api.public + '/customer/subscription/' + subscriptionId + '/activate';
      const data = 'product=' + productId + '&variant=' + variantId + (cadence ? '&cadence=' + cadence : '') + (discount ? '&discount=' + discount : '');

      if (this.debug) {
        console.log(url, data);
      }
      //return;

      const errorMsg = '<div class="error-message"><h4>Problem Encountered</h4><p>Please contact <a href="mailto:' + statelyVars.email.cx + '">customer support</a> for assistance with your account.</p></div>';

      $.ajax({
        type: 'GET',
        url: url,
        data: data,
        crossDomain: true,
        async: false,
        success: (response) => {
          if (!response.success) {
            console.error('📦 Unable to reactivate subscription', response.error || '');
            document.querySelector('.cta').innerHTML = errorMsg;
            return;
          }

          if (this.debug) {
            console.log('📦 Subscription reactivated');
          }

          document.querySelector('.section-head').classList.add('hidden');
          document.querySelector('.plan-details').classList.add('hidden');
          document.querySelector('.cta').classList.add('hidden');
          document.querySelector('.confirmation-message').classList.remove('hidden');
        },
        error: (xhr, status, error) => {
          console.error('📦 Unable to reactivate subscription', error);
          document.querySelector('.cta').innerHTML = errorMsg;
        }
      });
    });
  }

  initializeSelectionModal(modal) {
    const button = document.getElementById('change-' + modal + '-button');
    if (!button) {
      return;
    }

    button.addEventListener('click', () => {
      const modalOverlay = document.getElementById('modal-overlay');
      const modalElement = document.getElementById(modal + '-selection');

      if (modal === 'plan') {
        this.initializePlanModal(modalElement);
      } else if (modal === 'cadence') {
        this.initializeCadenceModal(modalElement);
      }

      modalOverlay.classList.add('active');
      modalElement.classList.add('active');
    });
  }

  initializeCadenceModal(modalElement) {
    modalElement.querySelector('.update-cadence-button').addEventListener('click', (e) => {
      e.preventDefault();
      const cadence = document.querySelector('input[name="cadence"]:checked').value;
      console.log('Updating cadence to', cadence);
      document.getElementById('plan-actions').setAttribute('data-cadence', cadence);
      document.querySelectorAll('.cadence').forEach(element => {
        element.textContent = (cadence > 1 ? cadence : '') + ' month' + (cadence > 1 ? 's' : '');
      });
      this.closeModal();
    });
  }

  initializePlanModal(modalElement) {
    modalElement.querySelector('.plans').innerHTML = document.getElementById('plans').innerHTML;
    modalElement.querySelectorAll('.plan').forEach(plan => {
      plan.addEventListener('click', (e) => {
        const plan = e.target.closest('.plan');
        if (plan.classList.contains('selected')) return;

        modalElement.querySelectorAll('#plan-selection .plan.selected').forEach(p => {
          p.classList.remove('selected');
        });

        plan.classList.add('selected');
      });
    });

    modalElement.querySelector('.update-plans-button').addEventListener('click', (e) => {
      e.preventDefault();
      const selectedPlan = modalElement.querySelector('.plan.selected');
      console.log('Updating plan to', selectedPlan.querySelector('.plan-title').textContent);
      document.getElementById('plans').querySelector('.plan.selected').classList.remove('selected');
      document.getElementById('plans').querySelector('[data-product-id="' + selectedPlan.dataset.productId + '"]').classList.add('selected');
      this.closeModal();
    });
  }

  getSubscriptionDetails() {
    const redirectToPlans = () => {
      if (!Shopify.designMode) {
        window.location.href = statelyVars.url.plans;
      }
    };

    const searchParams = new URLSearchParams(window.location.search);
    let email = searchParams.get('email');
    if (!email) {
      email = statelyVars.customer ? statelyVars.customer.email : '';
      if (!email) {
        redirectToPlans();
        return;
      }
    }

    const url = statelyVars.api.public + '/customer/' + email + '/subscriptions';

    if (this.debug) {
      console.log('📦 Fetching subscription details from', url);
    }

    $.ajax({
      type: 'GET',
      url: url,
      data: 'summary=true&status=cancelled&response=json',
      crossDomain: true,
      async: false,
      success: (response) => {
        if (!response.data || response.data.length === 0) {
          redirectToPlans();
          return;
        }
        if (this.debug) {
          console.log('📦 Subscription details received', response.data);
        }

        const subscription = Object.values(response.data)[0];

        this.setPlanDetails(subscription);
      },
      error: (xhr, status, error) => {
        console.error('📦 Unable to fetch subscription details', error);
        redirectToPlans();
      }
    });
  }

  setPlanDetails(subscription) {
    let planCard = document.querySelector('.plan[data-product-id="' + subscription.product_id + '"]');
    if (!planCard) {
      const planName = subscription.plan_name.toLowerCase().split(' ')[0];
      document.querySelectorAll('.plan').forEach(plan => {
        if (plan.querySelector('.plan-title').textContent.toLowerCase().indexOf(planName) !== -1) {
          planCard = plan;
        }
      });
    }
    if (!planCard) {
      console.error('📦 Plan card not found for product ID:', subscription.product_id);
      window.location.href = statelyVars.url.plans;
      return;
    }
    planCard.classList.add('selected');

    document.querySelectorAll('.cadence').forEach(element => {
      element.textContent = (subscription.frequency > 1 ? subscription.frequency : '') + ' ' + subscription.unit + (subscription.frequency > 1 ? 's' : '');
    });

    document.getElementById('plan-actions').setAttribute('data-subscription-id', subscription.subscription_id);

    let frequency = subscription.frequency;
    if (frequency > 12) {
      frequency = Math.round(frequency / 30);
    }
    if (frequency > 3 || frequency < 1) {
      frequency = 1;
    }
    document.getElementById('cadence-' + frequency + '-month').checked = true;
  }

  closeModal() {
    document.getElementById('modal-overlay').classList.remove('active');
    const activeModal = document.querySelector('#modal-overlay .active');
    if (activeModal) {
      activeModal.classList.remove('active');
    }
  }

  initializeModal() {
    document.querySelectorAll('#modal-overlay, .modal-close').forEach(element => {
      element.addEventListener('click', (e) => {
        if (e.target.id === 'modal-overlay' || e.target.classList.contains('modal-close')) {
          this.closeModal();
        }
      });
      element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
          e.preventDefault();
          this.closeModal();
        }
      });
    });

    const planVideoTab = document.getElementById('plan-video-tab');
    if (planVideoTab) {
      planVideoTab.addEventListener('click', () => {
        const modalOverlay = document.getElementById('modal-overlay');
        modalOverlay.classList.add('active');

        const videoModal = document.getElementById('plan-video');
        videoModal.classList.add('active');

        const video = videoModal.querySelector('video');
        if (video) {
          video.play();

          modalOverlay.addEventListener('click', (e) => {
            if (e.target === modalOverlay || e.target.classList.contains('modal-close')) {
              video.pause();
              video.currentTime = 0;
            }
          });
        }
      });
    }
  }

  adjustCart() {
    // Remove any subscription products in cart
    const removeSubProducts = ((cart) => {
      if (!cart.items || cart.items.length === 0) return;

      let hasSub = false;
      let items = {};
      cart.items.forEach((i) => {
        if (i.selling_plan_allocation?.selling_plan?.id) {
          items[i.key] = 0;
          hasSub = true;
        }
      });

      if (hasSub) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: items
          })
        }).then(response => {
          console.log('🛒 Removed subscription products from cart', items);
        }).catch((error) => {
          console.error('🛒 Unable to remove subscription products from cart', items);
        });
      }
    });

    // Add theme data to cart attributes
    const cartAttributes = {
      'theme': window.Shopify.theme.name,
      'theme_id': window.Shopify.theme.id
    };

    const quizData = localStorage.getItem('quiz_data');
    if (quizData) {
      cartAttributes['quiz_data'] = quizData;
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('quizError')) {
      cartAttributes['quiz_error'] = searchParams.get('quizError');
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        attributes: cartAttributes
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log(cart);
      console.log('🛒 Cart attributes updated', cartAttributes);
      this.currency.code = cart.currency;
      setTimeout(() => {
        removeSubProducts(cart);
      }, 1000);
    }).catch((error) => {
      console.error('🛒 Unable to update cart attributes', cartAttributes);
    });

  }

  showUpsell(variantId, sellingPlan, upsell) {
    upsell = typeof upsell === 'string' ? JSON.parse(upsell) : upsell;
    const upsellProduct = document.querySelector('.plan[data-handle="' + upsell.product + '"]');
    const modal = document.getElementById('plan-upsell');
    const overlay = document.getElementById('modal-overlay');

    let ci = null;
    const clearTimer = () => {
      if (ci) {
        clearInterval(ci);
      }
    };

    const declineUpsell = (() => {
      clearTimer();
      this.closeModal();
      this.selectPlan(variantId, sellingPlan);
    });

    if (!upsell || !modal || !upsellProduct) {
      // Bad configuration
      console.error('🛒 Invalid upsell configuration');
      declineUpsell();
    }

    const price = upsell.price || upsellProduct.querySelector('.plan-price span').textContent;
    const priceInt = parseInt(price.replace(this.currency.symbol, ''));
    const discountPrice = this.currency.symbol + Math.ceil(upsell.discount_type === 'percent' ? priceInt * (1 - (upsell.discount_amount / 100)) : priceInt - upsell.discount_amount);

    // Inject upsell product details into modal
    modal.querySelector('.upsell-discount-amount').textContent = upsell.discount_type === 'percent' ? upsell.discount_amount + '%' : this.currency.symbol + upsell.discount_amount;
    modal.querySelector('.upsell-title').textContent = upsell.title || upsellProduct.querySelector('.plan-title').textContent;
    modal.querySelector('.upsell-subtitle').textContent = upsell.subtitle || upsellProduct.querySelector('.included').textContent;
    modal.querySelector('.upsell-retail').textContent = upsell.retail || upsellProduct.querySelector('.retail').textContent;
    modal.querySelector('.upsell-features').innerHTML = upsell.features || upsellProduct.querySelector('ul').innerHTML;
    modal.querySelector('.upsell-regular-price').textContent = price;
    modal.querySelector('.upsell-discount-price').textContent = discountPrice;
    if (upsell.image) {
      const image = upsell.image.replace('?v=', '?width=525&v=');
      modal.querySelector('.upsell-image').innerHTML = `<img src="${image}" alt="${upsell.product.title}" />`;
    }
    if (upsell.countdown) {
      modal.querySelector('.upsell-countdown').textContent = upsell.countdown;
    }
    if (upsell.preheader_text) {
      modal.querySelector('.upsell-label').textContent = upsell.preheader_text;
    }
    if (upsell.fine_print) {
      modal.querySelector('.upsell-fine-print').innerHTML = upsell.fine_print.replaceAll('[price]', price).replaceAll('[discount_price]', discountPrice);
    }

    const bgColor = upsell.bg_color || '#FFFFFF';
    const textColor = upsell.text_color || '#000000';
    modal.querySelector('.upsell-content').style.background = bgColor;
    modal.querySelector('.upsell-content').style.color = textColor;
    modal.querySelector('.upsell-cta button').style.background = textColor;
    modal.querySelector('.upsell-cta button').style.borderColor = textColor;
    modal.querySelector('.upsell-cta button').style.color = bgColor;

    // Show upsell modal
    modal.classList.add('active');
    overlay.classList.add('active');

    const oldUpsellButton = modal.querySelector('.upsell-cta button');
    const upsellButton = oldUpsellButton.cloneNode(true);
    oldUpsellButton.replaceWith(upsellButton);
    upsellButton.addEventListener('click', () => {
      clearTimer();
      this.closeModal();
      this.selectPlan(upsellProduct.dataset.variantId, upsellProduct.dataset.sellingPlan, null, upsell.discount);
    });
    
    const oldDeclineButton = modal.querySelector('.upsell-decline button');
    const declineButton = oldDeclineButton.cloneNode(true);
    oldDeclineButton.replaceWith(declineButton);
    declineButton.addEventListener('click', () => {
      declineUpsell();
    });

    // Countdown timer
    if (upsell.countdown) {
      ci = setInterval(() => {
        const countdown = document.querySelector('.upsell-countdown');
        if (countdown && countdown.textContent) {
          const remaining = parseInt(countdown.textContent);
          if (remaining > 0) {
            countdown.textContent = remaining - 1;
          } else {
            declineUpsell();
          }
        }
      }, 1000);
    }
  }

  toggleFeatures(id) {
    const content = document.getElementById(id);
    const button = content.previousElementSibling;
    const arrow = button.querySelector('.toggle-arrow');
    
    content.classList.toggle('tw-hidden');
    arrow.style.transform = content.classList.contains('tw-hidden') ? '' : 'rotate(180deg)';
  }

  selectPlan(variantId, sellingPlan, upsell, discount) {
    upsell = typeof upsell === 'undefined' ? false : upsell;
    discount = typeof discount === 'undefined' ? false : discount;

    // If upsell is available, show modal
    if (upsell) {
      return this.showUpsell(variantId, sellingPlan, upsell);
    }
  
    console.log('🛒 Add to cart', {variantId: variantId, sellingPlanId: sellingPlan});

    // Proceed with add to cart + checkout
    const customerId = localStorage.getItem('odoo_customer_id') || '';
  
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'selling_plan': sellingPlan,
        'properties': {
          '_odoo_customer_id': customerId
        }
      }]
    };
  
    const redirectToCheckout = () => {
      if (this.debugStop) {
        console.warn('🪲 Checkout stopped for debugging');
        return;
      }

      //this.toggleLoading();
      setTimeout(() => {
        window.location.href = '/checkout' + (discount ? '?discount=' + discount : '');
      }, 300);
    };
  
    const addToCart = () => {
      //this.toggleLoading();
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(cart => {
        console.log('🛒 Items added to cart', formData);
        setTimeout(redirectToCheckout, 1000);
      }).catch(error => {
        console.error('🛒 Unable to add items to cart', error);
        setTimeout(addToCart, 1000);
      });
    };
  
    addToCart();

    // Convert goal - added plan to cart
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100140016"]);

    this.triggerDataLayerEvent(variantId);
  }

  toggleLoading() {
    if (this.debugStop) {
      return false;
    }
    const loading = document.querySelector('.loading');
    const isLoading = loading && !loading.classList.contains('hidden');
    if (loading) {
      loading.classList.toggle('active', isLoading);
    }
    const overlay = document.getElementById('modal-overlay');
    if (overlay) {
      overlay.classList.toggle('active', isLoading);
      if (isLoading) {
        // Remove previous click event listeners
        const overlayClone = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(overlayClone, overlay);
      }
    }
  }

  triggerDataLayerEvent(variantId) {
    const planCard = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!planCard) {
      console.error('🛒 Plan card not found for variantId:', variantId);
      return;
    }

    const contentName = planCard?.querySelector('h3')?.innerText.trim() || 'Plan';
    const priceText = planCard?.querySelector('.plan-price span')?.innerText.replace('$', '') || '0';
    const price = parseFloat(priceText);
    const currency = this.currency.code;
    const category = 'subscription';
    const eventId = 'plan-' + variantId + '-' + Date.now();
  
    // Always track addToCart event, even if no upsell
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currency: currency,
        value: price,
        items: [{
          item_name: contentName,
          item_id: variantId,
          item_category: category,
          price: price,
          item_variant: variantId
        }]
      },
      'Add to Cart - Product Name': contentName,
      'Add to Cart - Add Array': [{
        'Facebook - product identifier': variantId
      }],
      'Add to Cart - Category': category,
      'Add to Cart - Price': price,
      'Facebook - product group': 'product_group',
      'Global - Currency Code': currency,
      'event_id': eventId
    });
  
  }

}

if (document.getElementById('plans') || document.getElementById('abandon-cart') || document.getElementById('plan-actions')) {
  window.addEventListener('DOMContentLoaded', () => {
    window.plans = new Plans();
  });
}
